import { SessionTitleConfig } from '@core/models/built/procedure-step-config.model';

// eslint-disable-next-line no-shadow
export enum ManageableFields {
  registrationNumber = 'registrationNumber',
  deliveryPoint = 'deliveryPoint',
  department = 'department',
  purpose = 'purpose',
  contract = 'contract',
  measures = 'measures'
}

// eslint-disable-next-line no-shadow
export enum EmployeeType {
  confirmed = 'confirmed',
  notConfirmed = 'notConfirmed'
}

export interface ManageEmployeeConfig extends SessionTitleConfig {
  manageableFields?: ManageableFields[];
  employeeType: EmployeeType;
}
